import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import i18next from '../../lang';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import { adminStyles } from '../../theme/adminStyles';

interface CategoryFormData {
  name: string;
}

const ProductCategoryForm: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [formData, setFormData] = useState<CategoryFormData>({
    name: '',
  });

  useEffect(() => {
    if (id) {
      fetchCategory();
    }
  }, [id]);

  const fetchCategory = async () => {
    try {
      const response = await axios.get(`/admin/product-categories/${id}`);
      const category = response.data;
      setFormData({
        name: category.name,
      });
    } catch (error) {
      console.error('カテゴリーの照会に失敗しました：', error);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      if (id) {
        await axios.put(`/admin/product-categories/${id}`, formData);
      } else {
        await axios.post('/admin/product-categories', formData);
      }
      navigate('/admin/product-categories');
    } catch (error) {
      console.error('カテゴリーの保存に失敗しました：', error);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Container maxWidth="lg" sx={adminStyles.pageContainer}>
      {/* ヘッダー */}
      <Box sx={adminStyles.headerBox}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton
            onClick={() => navigate('/admin/product-categories')}
            sx={{ bgcolor: '#f5f5f7', '&:hover': { bgcolor: '#e8e8e8' } }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>
      </Box>

      <Paper sx={adminStyles.contentPaper}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={i18next.t('product_category.type_name')}
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                InputProps={{ style: { fontSize: '0.8rem' } }}
                InputLabelProps={{ style: { fontSize: '0.8rem' } }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/admin/product-categories')}
                  sx={{ fontSize: '0.8rem' }}
                >
                  {i18next.t('common.cancel')}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ fontSize: '0.8rem' }}
                >
                  {i18next.t('common.save')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  );
};

export default ProductCategoryForm;